import { render, staticRenderFns } from "./tabTwoList.vue?vue&type=template&id=068612dc&scoped=true&"
import script from "./tabTwoList.vue?vue&type=script&lang=js&"
export * from "./tabTwoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068612dc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('068612dc')) {
      api.createRecord('068612dc', component.options)
    } else {
      api.reload('068612dc', component.options)
    }
    module.hot.accept("./tabTwoList.vue?vue&type=template&id=068612dc&scoped=true&", function () {
      api.rerender('068612dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/operate/fissionStatistics/detail/tabTwoList.vue"
export default component.exports